<ng-container *ngIf="product">
  <button mat-fab (click)="addToCartProduct(product)">
    <mat-icon aria-hidden="false" class="material-icons"> shopping_cart </mat-icon>
  </button>
</ng-container>
